'use client'
import * as React from 'react'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import { AmplitudeEvents, sendAmplitudeEvent } from '@repo/analytics/amplitude/utils'
import { AppRoutes } from '@repo/web-utils/app-routes'
import { Link } from '@repo/web-ui/components/link'

import { LFS_URL } from '@web/utils/env'
import { FlameIcon } from '@web/components/icons/flame'
import {
  PAYMENT_ENTRY_POINTS,
  savePaymentModalEntryPoint,
} from 'payments/payments-dialog/analytics'

function getSparkHref(query: string) {
  return `${AppRoutes.STUDIO_TOOL_FLOW}?${
    query?.length > 0 ? `prompt=${encodeURIComponent(query)}&` : ''
  }`
}

function fireSparkEvent(query: string) {
  savePaymentModalEntryPoint(PAYMENT_ENTRY_POINTS.SEARCH_PAGE_BANNER)
  sendAmplitudeEvent(AmplitudeEvents.CLICKED_FLOW_BANNER, { prompt: query })
}

export function SparkBanner({ query }: { query: string }) {
  const t = useTranslations('pages.search.banners.spark')

  return (
    <div
      style={{
        backgroundImage: `url("${LFS_URL}/web/pages/search/spark-banner-cat-page-marketing.png")`,
      }}
      className="text-cf-white flex w-full flex-col items-center justify-between gap-[10px] bg-cover px-5 py-[10px] md:flex-row"
    >
      <Link
        href={getSparkHref(query)}
        target="_blank"
        onClick={() => fireSparkEvent(query)}
        className="flex w-full items-center justify-between gap-[10px] outline-none"
      >
        <span className="flex items-center gap-[10px]">
          <Image
            src={`${LFS_URL}/web/pages/search/Spark-sub_fire.svg`}
            alt="Spark Logo"
            width={28}
            height={28}
          />
          <span className="font-bold text-white">{t('text')}</span>
        </span>
      </Link>
      <SparkIgniteButton query={query}>{t('cta')}</SparkIgniteButton>
    </div>
  )
}

export function SparkIgniteButton({
  query,
  children,
}: {
  query: string
  children: React.ReactNode
}) {
  return (
    <Link
      data-testid="studio-cta"
      href={getSparkHref(query)}
      target="_blank"
      onClick={() => fireSparkEvent(query)}
      className="bg-secondary-500 hover:bg-secondary-700 text-cf-white group flex min-h-[45px] min-w-[210px] shrink-0 items-center gap-1 rounded px-5 tracking-[1px] outline-none"
    >
      <div className="relative">
        <FlameIcon className="fill-cf-white size-4 transition-opacity duration-500 ease-in-out group-hover:opacity-0" />
        <Image
          src={`${LFS_URL}/web/pages/search/fire_yellow.gif`}
          className="absolute top-0 opacity-0 transition-opacity duration-500 ease-in-out group-hover:opacity-100"
          alt=""
          width={16}
          height={16}
        />
      </div>

      <span className="whitespace-normal font-bold [word-break:break-word]">{children}</span>
    </Link>
  )
}
